export default __webpack_public_path__ + "static/media/twenty-seven.4a77cac2.png";